import { Lang } from 'Roblox';
import angular from 'angular';

let premium = angular
    .module("premium", ["robloxApp"])
    .config(['languageResourceProvider', function (languageResourceProvider) {
            if (Lang.PremiumResources) {
                languageResourceProvider.setLanguageKeysFromFile(Lang.PremiumResources);
            }
        }]);

export default premium;